/**
 * Types for the Study Plan feature
 */

/**
 * Interface for Study Plan Topic
 */
export interface StudyPlanTopic {
  topic: string;
  targetHours: string;
  targetQuestions: number;
  learningResources: string[];
  notes: string;
}

/**
 * Interface for Study Plan Week
 */
export interface StudyPlanWeek {
  weekNumber: number;
  dateRange: string;
  theme: string;
  topics: StudyPlanTopic[];
}

/**
 * Interface for Study Plan
 */
export interface StudyPlan {
  id: string;
  testProgressId: string;
  userId: string;
  introduction: string;
  weeks: StudyPlanWeek[];
  conclusion: string;
  content: string; // Full content as generated by Gemini
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Enum for Study Plan Generation Status
 */
export enum StudyPlanGenerationStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

/**
 * Interface for Study Plan Generation Progress
 */
export interface StudyPlanGenerationProgress {
  id?: string;
  content: string;
  status: StudyPlanGenerationStatus;
  studyPlanId?: string;
  error?: string;
  updatedAt: Date;
}

/**
 * Interface for Study Plan Response
 */
export interface StudyPlanResponse {
  studyPlan: StudyPlan | null;
  generationProgress: StudyPlanGenerationProgress | null;
  testProgressId: string;
}

/**
 * Interface for Study Plan Stream Event
 */
export interface StudyPlanStreamEvent {
  type: 'start' | 'content' | 'complete' | 'error';
  content?: string;
  studyPlanId?: string;
  error?: string;
}
